export default __webpack_public_path__ + "static/media/stockholmchocolate.abfef010.jpg";